document.addEventListener('DOMContentLoaded', function() {
  const suggestionForms = document.querySelectorAll('.cart-suggestions form');
  
  suggestionForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const button = form.querySelector('.cart-suggestion-add-btn');
      const buttonText = button.querySelector('span:first-child');
      const buttonIcon = button.querySelector('.svg-wrapper');
      const originalText = buttonText.textContent;
      
      button.disabled = true;
      buttonText.textContent = 'adding...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        buttonText.textContent = 'added';
        
        // Fetch updated cart drawer HTML
        return fetch(window.location.href + '?section_id=cart-drawer');
      })
      .then(response => response.text())
      .then(html => {
        // Parse the HTML response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');
        const currentCartDrawer = document.querySelector('cart-drawer');
        
        if (newCartDrawer && currentCartDrawer) {
          // Replace the entire cart drawer content
          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
        }
        
        // Trigger cart update event for other components (header cart count, etc)
        document.dispatchEvent(new CustomEvent('cart:updated'));
        
        // Reset button after 1 second (in case suggestions are still visible)
        setTimeout(() => {
          if (button && buttonText) {
            button.disabled = false;
            buttonText.textContent = originalText;
          }
        }, 1000);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        button.disabled = false;
        buttonText.textContent = 'error';
        
        setTimeout(() => {
          buttonText.textContent = originalText;
        }, 2000);
      });
    });
  });
});
